import {
  ANALYTICS_RANGE_PRESETS,
  AnalyticsRangePreset,
  DEFAULT_GRANULARITY,
  DEFAULT_RANGE_PRESET_ID,
} from '../constants/analytics.constants';
import { AnalyticsGranularity } from '../types/analytics.types';

/**
 * Returns the preset matching `presetId`, falling back to the default preset
 * (and then the first preset in the list) if no match exists.
 */
export const findRangePreset = (presetId: string): AnalyticsRangePreset => {
  const match = ANALYTICS_RANGE_PRESETS.find((p) => p.id === presetId);
  if (match) return match;
  const fallback = ANALYTICS_RANGE_PRESETS.find((p) => p.id === DEFAULT_RANGE_PRESET_ID);
  if (fallback) return fallback;
  return ANALYTICS_RANGE_PRESETS[0];
};

export const getDefaultGranularity = (): AnalyticsGranularity => {
  const preset = ANALYTICS_RANGE_PRESETS.find((p) => p.id === DEFAULT_RANGE_PRESET_ID);
  return preset?.granularity ?? DEFAULT_GRANULARITY;
};
